Ext.define('SA.AppControllerState', {
    constructor(value) {
        this.value = value;
        this.observable = new Ext.util.Observable();
    },

    fireChange(lastValue, value) {
        var lastController = lastValue.getController(),
            lastMode = lastValue.getMode(),
            event = !lastValue.sameController(value) ? 'change:controller' : 'change:mode';

        this.observable.fireEvent(event, {lastController, lastMode, ...value.toObject()});
    },

    getController() {
        return this.value.getController();
    },

    isViewMode() {
        return this.value.isViewMode();
    },

    onChangeController(callback, scope) {
        this.observable.on('change:controller', callback, scope);
    },

    onChangeMode(callback, scope) {
        this.observable.on('change:mode', callback, scope);
    },

    set(value) {
        if (this.value.same(value)) {
            return;
        }

        var lastValue = this.value;

        this.value = value;

        this.fireChange(lastValue, value);
    }
});